<template>
  <div>
    <back-btn />
    <v-container>
      <v-row class="ml-3">
        <h4>Month : {{ $route.params.month }}</h4>
        <h4 class="ml-3">Year : {{ $route.params.year }}</h4>
      </v-row>
      <v-row>
        <v-col
          lg="3"
          md="4"
          sm="6"
          v-for="(item, i) in activities"
          v-bind:key="i"
        >
          <v-card class="card--shadow" @click="viewEachActivity(item.link)">
            <v-card-text>
              <h3 class="header_text">{{ item.text }}</h3>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import BackBtn from "@/components/navigation/BackBtn";
export default {
  components: { BackBtn },
  data: () => ({
    activities: [
      { link: "he", text: "HE" },
      { link: "home-visit", text: "Home Visit" },
      { link: "supervision-visit", text: "Supervision Visit" },
      { link: "counseling", text: "Counseling" },
    ],
  }),
  methods: {
    viewEachActivity(linkName) {
      console.log(linkName);
      this.$router.push({
        name: linkName,
        params: {
          month: this.$route.params.month,
          year: this.$route.params.year,
        },
      });
    },
  },
};
</script>

<style scoped>
.v-card {
  border-radius: 10px;
}
h3 {
  text-align: center;
}
.header_text {
  color: var(--primary-color);
  letter-spacing: 1px;
}
</style>
